import { useEffect, useState } from "react";
import { i18n, initializeI18n } from "../localization/i18n";
import { translate } from "../localization/translateService";
// Collage decorative doodles (Figma 1334-26955): cyan arc on the cyan card, yellow
// swoosh + corner-arrow by the "300+" card.
import whyDecoEllipse from "../stories/assets/why-deco-ellipse.svg";
import whyDecoRect from "../stories/assets/why-deco-rect.svg";
import whyDecoVector from "../stories/assets/why-deco-vector.svg";

// "Why learn Korean with DOTORE?" (Figma 391:4427)
// Left: title + intro + 3 features (icons FIXED theo Figma, xanh). Right: collage —
// cyan "Qualified Tutors" (trên-trái) + 2 ảnh + vàng "300+" (dưới-phải) + mũi tên.
// Localization: title/intro/features/collage labels = CMS props (Umbraco variant). When CMS
// empty -> i18n translate() defaults (NOT hardcoded English in markup).

// Iconsax Bold icons (gps-location / profile-tick / note-2), brand blue #3054F1 (exact Figma export).
const FEATURE_ICONS = [
  // location / target -> Clear learning roadmap
  <svg key="g" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M22 11.25H19.96C19.6 7.44 16.56 4.39 12.75 4.04V2C12.75 1.59 12.41 1.25 12 1.25C11.59 1.25 11.25 1.59 11.25 2V4.04C7.44 4.4 4.39 7.44 4.04 11.25H2C1.59 11.25 1.25 11.59 1.25 12C1.25 12.41 1.59 12.75 2 12.75H4.04C4.4 16.56 7.44 19.61 11.25 19.96V22C11.25 22.41 11.59 22.75 12 22.75C12.41 22.75 12.75 22.41 12.75 22V19.96C16.56 19.6 19.61 16.56 19.96 12.75H22C22.41 12.75 22.75 12.41 22.75 12C22.75 11.59 22.41 11.25 22 11.25ZM12 15.12C10.28 15.12 8.88 13.72 8.88 12C8.88 10.28 10.28 8.88 12 8.88C13.72 8.88 15.12 10.28 15.12 12C15.12 13.72 13.72 15.12 12 15.12Z" fill="#3054F1" /></svg>,
  // profile-tick -> Qualified tutors
  <svg key="p" width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M12 2C9.38 2 7.25 4.13 7.25 6.75C7.25 9.32 9.26 11.4 11.88 11.49C11.96 11.48 12.04 11.48 12.1 11.49C12.12 11.49 12.13 11.49 12.15 11.49C12.16 11.49 12.16 11.49 12.17 11.49C14.73 11.4 16.74 9.32 16.75 6.75C16.75 4.13 14.62 2 12 2Z" fill="#3054F1" /><path d="M17.0809 14.16C14.2909 12.3 9.74094 12.3 6.93094 14.16C5.66094 15 4.96094 16.15 4.96094 17.38C4.96094 18.61 5.66094 19.75 6.92094 20.59C8.32094 21.53 10.1609 22 12.0009 22C13.8409 22 15.6809 21.53 17.0809 20.59C18.3409 19.74 19.0409 18.6 19.0409 17.36C19.0309 16.14 18.3409 14.99 17.0809 14.16ZM14.3309 16.56L11.8109 19.08C11.6909 19.2 11.5309 19.26 11.3709 19.26C11.2109 19.26 11.0509 19.19 10.9309 19.08L9.67094 17.82C9.43094 17.58 9.43094 17.18 9.67094 16.94C9.91094 16.7 10.3109 16.7 10.5509 16.94L11.3709 17.76L13.4509 15.68C13.6909 15.44 14.0909 15.44 14.3309 15.68C14.5809 15.92 14.5809 16.32 14.3309 16.56Z" fill="#3054F1" /></svg>,
  // note-2 -> Diverse learning content
  <svg key="n" width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true"><path d="M16.904 26.6094C17.2704 26.6946 17.3039 27.1744 16.9471 27.2934L14.8405 27.9867C9.54712 29.6934 6.76046 28.2667 5.04046 22.9734L3.33379 17.7067C1.62712 12.4134 3.04045 9.61335 8.33379 7.90668L9.37112 7.56315C9.77398 7.42974 10.1617 7.83212 10.0393 8.23846C9.92722 8.61042 9.82211 9.0065 9.72045 9.42668L8.41379 15.0134C6.94712 21.2934 9.09379 24.76 15.3738 26.2534L16.904 26.6094Z" fill="#3054F1" /><path d="M22.8929 4.28005L20.6663 3.76005C16.2129 2.70672 13.5596 3.57338 11.9996 6.80005C11.5996 7.61338 11.2796 8.60005 11.0129 9.73339L9.70626 15.3201C8.39959 20.8934 10.1196 23.6401 15.6796 24.9601L17.9196 25.4934C18.6929 25.6801 19.4129 25.8001 20.0796 25.8534C24.2396 26.2534 26.4529 24.3067 27.5729 19.4934L28.8796 13.9201C30.1863 8.34672 28.4796 5.58672 22.8929 4.28005ZM20.3863 17.7734C20.2663 18.2267 19.8663 18.5201 19.4129 18.5201C19.3329 18.5201 19.2529 18.5067 19.1596 18.4934L15.2796 17.5067C14.7463 17.3734 14.4263 16.8267 14.5596 16.2934C14.6929 15.7601 15.2396 15.4401 15.7729 15.5734L19.6529 16.5601C20.1996 16.6934 20.5196 17.2401 20.3863 17.7734ZM24.2929 13.2667C24.1729 13.7201 23.7729 14.0134 23.3196 14.0134C23.2396 14.0134 23.1596 14.0001 23.0663 13.9867L16.5996 12.3467C16.0663 12.2134 15.7463 11.6667 15.8796 11.1334C16.0129 10.6001 16.5596 10.2801 17.0929 10.4134L23.5596 12.0534C24.1063 12.1734 24.4263 12.7201 24.2929 13.2667Z" fill="#3054F1" /></svg>,
];


const hasDigit = (t) => /\d/.test(String(t || ""));

export default function BecomeTeacherSection({ props }) {
  const [lang, setLang] = useState(null);
  const [t, setT] = useState({});

  // Init i18n + track current language (re-translate on language change)
  useEffect(() => {
    if (!i18n.isInitialized) {
      initializeI18n().then(() => setLang(i18n.language));
    } else {
      setLang(i18n.language);
    }
  }, []);

  // i18n defaults — used only when the CMS field is empty (no hardcoded English in markup)
  useEffect(() => {
    let active = true;
    (async () => {
      const out = {};
      out.title = await translate("UMBRACO_LANDING.HOME.WHY.TITLE", false, "Why learn Korean with DOTORE?");
      out.intro = await translate("UMBRACO_LANDING.HOME.WHY.INTRO", false, "DOTORE helps you understand your level, choose the right learning path, and study with tutors that match your goals.");
      out.feature1Title = await translate("UMBRACO_LANDING.HOME.WHY.FEATURE1_TITLE", false, "Clear learning roadmap");
      out.feature1Desc = await translate("UMBRACO_LANDING.HOME.WHY.FEATURE1_DESC", false, "A level- and goal-based path from beginner to TOPIK 6, so you always know what's next.");
      out.feature2Title = await translate("UMBRACO_LANDING.HOME.WHY.FEATURE2_TITLE", false, "Qualified tutors");
      out.feature2Desc = await translate("UMBRACO_LANDING.HOME.WHY.FEATURE2_DESC", false, "Verified native Korean tutors matched to your level, schedule, and learning style.");
      out.feature3Title = await translate("UMBRACO_LANDING.HOME.WHY.FEATURE3_TITLE", false, "Diverse learning content");
      out.feature3Desc = await translate("UMBRACO_LANDING.HOME.WHY.FEATURE3_DESC", false, "Live classes, VOD lessons, and 300+ study materials — practice the way that suits you.");
      out.statValue = await translate("UMBRACO_LANDING.HOME.WHY.STAT_VALUE", false, "300+");
      out.statLabel = await translate("UMBRACO_LANDING.HOME.WHY.STAT_LABEL", false, "Study Materials");
      out.badgeTitle = await translate("UMBRACO_LANDING.HOME.WHY.BADGE_TITLE", false, "Qualified Tutors");
      out.badgeText = await translate("UMBRACO_LANDING.HOME.WHY.BADGE_TEXT", false, "Study Materials");
      if (active) setT(out);
    })();
    return () => { active = false; };
  }, [lang]);

  // CMS first (Umbraco variant); i18n default when CMS empty
  const title = t.title || props?.whyTitle || props?.becomeTeacherTitle1 || "";
  const intro = t.intro || props?.whyIntro || props?.becomeTeacherTitle2 || "";

  const DEFAULT_FEATURES = [
    { title: t.feature1Title, description: t.feature1Desc },
    { title: t.feature2Title, description: t.feature2Desc },
    { title: t.feature3Title, description: t.feature3Desc },
  ];

  const features = DEFAULT_FEATURES;
  const highlights = Array.isArray(props?.highlights) ? props.highlights : [];

  // Robust mapping so it always matches Figma regardless of how CMS blocks are filled.
  const images = highlights.filter((h) => h.image && h.image !== "");
  const stat = highlights.find((h) => h.value) || highlights.find((h) => !h.image && hasDigit(h.title));
  const badge = highlights.find((h) => h !== stat && !h.image && (h.title || h.text));

  const statValue = t.statValue || stat?.value || stat?.title || "";
  const statLabel = t.statLabel || (stat?.value ? stat?.title : stat?.text) || "";
  const badgeTitle = t.badgeTitle || badge?.title || "";
  const badgeText = t.badgeText || badge?.text || "";

  return (
    <section className="why-section">
      <div className="why-section__inner">
        <div className="why-section__left">
          <div className="why-section__heading animate-on-scroll">
            <h2 className="why-section__title">{title}</h2>
            {intro && <p className="why-section__intro">{intro}</p>}
          </div>

          <ul className="why-features">
            {features.map((f, i) => (
              <li className="why-feature animate-on-scroll" key={i}>
                <span className="why-feature__icon">{FEATURE_ICONS[i % FEATURE_ICONS.length]}</span>
                <div className="why-feature__body">
                  <h3 className="why-feature__title">{f.title}</h3>
                  {f.description && <p className="why-feature__desc">{f.description}</p>}
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div className="why-section__right animate-on-scroll">
          <div className="why-collage">
            <div className="why-collage__photo why-collage__photo--lg">
              {images[0]?.image && <img src={images[0].image} alt="" />}
            </div>
            <div className="why-collage__photo why-collage__photo--sm">
              {images[1]?.image && <img src={images[1].image} alt="" />}
            </div>

            <div className="why-collage__badge">
              <span className="why-collage__badge-title">{badgeTitle}</span>
              <span className="why-collage__badge-text">{badgeText}</span>
              {/* cyan arc: clipped inside the cyan card (Figma 1334-26989) */}
              <img className="why-collage__deco why-collage__deco--ellipse" src={whyDecoEllipse} alt="" aria-hidden="true" />
            </div>

            <div className="why-collage__stat">
              <span className="why-collage__stat-value">{statValue}</span>
              <span className="why-collage__stat-label">{statLabel}</span>
              {/* swoosh: rotated, clipped inside the card (Figma 1334-26984) */}
              <img className="why-collage__deco why-collage__deco--rect" src={whyDecoRect} alt="" aria-hidden="true" />
            </div>

            {/* yellow chevron-arrow over the collage bottom-right (Figma 1334-26992) */}
            <img className="why-collage__deco why-collage__deco--vector" src={whyDecoVector} alt="" aria-hidden="true" />
          </div>
        </div>
      </div>
    </section>
  );
}
